import React from 'react'
import Container from '../components/Container'
import { ScrollFadeIn } from '../../../components/ScrollFadeIn'
import { CalculatorIcon } from '@heroicons/react/outline'

const CalculatorCTA = () => {
  return (
  <Container bgColor="">
        <ScrollFadeIn>
          <h1 className="  text-gray-800 text-center heading-1  mx-auto ">
            See how traditional financial advisor <span className="text-secondary-500"> fees add up</span> over your
            lifetime.
          </h1>
        </ScrollFadeIn>
        <ScrollFadeIn className="mt-10 sm:mt-16 flex justify-center">
          <a
            href="/fee-savings-calculator"
            className=' btn-4xl btn-dark-blue flex items-center
'
          >
            <CalculatorIcon className="h-7 w-7 mr-3" />
            <p> Fee Savings Calculator</p>

          </a>
          {/* <Calculator /> */}
        </ScrollFadeIn>

      </Container>
 )
}

export default CalculatorCTA